var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"flex w-1/2 mobile:w-full mobile:px-2 mobile:mx-0 mx-auto"},[_c('add-company-client',{on:{"clientSaved":_vm.handleAddedClient}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }